import { Nullable } from '@/type-utils';
import { createContext } from 'react';
import { IErrorAlertContext } from './IErrorAlertContext';

export const ErrorAlertContext =
  createContext<Nullable<IErrorAlertContext>>(null);
ErrorAlertContext.displayName = 'ErrorAlertContext';

export { useErrorAlertProviderValue } from './useErrorAlertProviderValue';
